"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CopyToClipboard = void 0;
var FragmentTooltipMethods = _interopRequireWildcard(require("./FragmentTooltip.js"));
var _ContentCopy = _interopRequireDefault(require("@mui/icons-material/ContentCopy"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _function = require("../../utils/type-checks/function");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CopyToClipboard = (event, value) => {
    let copyText,
      result = false;
    if (event && (0, _string.isStringOfLength)(value) && (0, _function.isFunction)(event.preventDefault)) {
      event.preventDefault();
      try {
        if ((0, _object.isObject)(navigator) && (0, _object.isObject)(navigator.clipboard) && (0, _function.isFunction)(navigator.clipboard.writeText)) {
          // Copies button value to clipboard
          navigator.clipboard.writeText(value);
          result = true;
        } else if ((0, _object.isObject)(document) && (0, _function.isFunction)(document.execCommand)) {
          copyText = document.createElement("textarea");
          copyText.style.positon = "absolute";
          copyText.style.height = "1px";
          copyText.style.left = "-9999px";
          copyText.style.opacity = "0";
          copyText.style.top = "-9999px";
          copyText.style.width = "1px";
          copyText.value = value;
          document.body.appendChild(copyText);
          copyText.select();
          document.execCommand("copy");
          document.body.removeChild(copyText);
          result = true;
        } else {
          throw new Error();
        }
      } catch (e) {
        result = false;
      }
    }
    if (result === true) {
      console.log(`Copied ${value}`);
    } else {
      console.log("Not Copied");
    }
    return result;
  },
  FragmentTooltip = props => {
    const {
        children,
        id,
        open = false,
        type,
        ...rest
      } = props,
      value = `${type}-${id}`,
      [isOpen, setIsOpen] = (0, _react.useState)(open),
      handleClick = e => FragmentTooltipMethods.CopyToClipboard(e, value);
    return /*#__PURE__*/_react.default.createElement(_material.Tooltip, _extends({
      arrow: true,
      onClose: () => setIsOpen(false),
      onOpen: () => setIsOpen(true),
      open: isOpen,
      slotProps: {
        arrow: {
          sx: {
            color: "rgba(0,0,0,0.65)"
          }
        },
        tooltip: {
          sx: {
            alignItems: "center",
            backgroundColor: "rgba(0,0,0,0.65)",
            borderRadius: "0.5rem",
            display: "flex",
            justifyContent: "center",
            padding: "0.5rem 0.5rem 0.5rem 1.5rem"
          }
        }
      },
      title: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        sx: {
          fontSize: "1.2rem"
        }
      }, value), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
        onClick: handleClick,
        sx: {
          marginLeft: "0.5rem"
        }
      }, /*#__PURE__*/_react.default.createElement(_ContentCopy.default, {
        alt: "Copy to Clipboard",
        sx: {
          color: "white",
          fontSize: "1.8rem"
        }
      })))
    }, rest), children);
  };
exports.CopyToClipboard = CopyToClipboard;
FragmentTooltip.propTypes = {
  children: _propTypes.default.any.isRequired,
  id: _propTypes.default.string.isRequired,
  open: _propTypes.default.bool,
  type: _propTypes.default.string.isRequired
};
var _default = exports.default = FragmentTooltip;